import React, { ChangeEvent, FC } from 'react'
import { BreadType } from 'types/bread'
import { Card } from 'components/Card'
import ScheduleCollectiveCard from './ScheduleCollectiveCard'
import { HorizontalLine } from 'components/Utility'
import { getBreadShortName } from 'lib/helper'

type Props = {
  breads: BreadType[]
  selectedBreads: BreadType[]
  selectBread: (event: ChangeEvent<HTMLInputElement>) => void
}

const ScheduleCollectiveCardList: FC<Props> = (props) => {
  const { breads, selectedBreads, selectBread } = props
  return (
    <Card>
      {breads.map((bread, index) => {
        if (!bread.bread_ref) return
        const isSelected = selectedBreads.some((_bread) => _bread.bread_ref?.id === bread.bread_ref?.id)
        return (
          <React.Fragment key={bread.bread_ref.id}>
            {index !== 0 && <HorizontalLine verticalMargin={16} />}
            <ScheduleCollectiveCard
              breadId={bread.bread_ref.id}
              breadName={getBreadShortName(bread)}
              imageUrl={bread.image_urls[0] || ''}
              isSelected={isSelected}
              selectBread={selectBread}
            />
          </React.Fragment>
        )
      })}
    </Card>
  )
}

export default ScheduleCollectiveCardList
